"use strict";

exports.__esModule = true;
exports["default"] = void 0;

/**
 * Flattens (reduces to one array) a tree of routes.
 * @param {array} routes A tree of route objects to flatten.
 * @package
 */
var flattenRoutes = function flattenRoutes(routes) {
  return routes.map(function (route) {
    return route.children ? [route].concat(flattenRoutes(route.children)) : route;
  }).reduce(function (acc, cur) {
    return Array.isArray(cur) ? [].concat(acc, cur) : [].concat(acc, [cur]);
  }, []);
};

var _default = flattenRoutes;
exports["default"] = _default;